var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "ai-requests-product-card-wrapper d-flex justify-content-between",
      staticStyle: { "max-width": "720px" },
    },
    [
      _c(
        "ib-card",
        {
          staticClass: "name-price-wrapper",
          staticStyle: { flex: "1" },
          attrs: { animation: false },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center",
            },
            [
              _c("div", { staticClass: "name" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.value) +
                    " " +
                    _vm._s(_vm.$t("aiAssistancePage.aiRequests")) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "price" }, [
                _vm._v(" " + _vm._s(_vm.price ? _vm.price : "-") + " "),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "d-flex", staticStyle: { "margin-left": "16px" } },
        [
          _c(
            "ib-button",
            {
              attrs: { disabled: !_vm.price },
              on: {
                click: function ($event) {
                  return _vm.$emit("buy-now", _vm.productId)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("aiAssistancePage.buyNow")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }